'use strict';

/*@ngInject*/
module.exports = function publicRoutesService($http) {
    this.getRoutesBySearch = function (filter) {
        return $http.post('routes/getRoutesBySearch/', { filter: filter });
    };

    this.getRouteDataById = function (routeId) {
        return $http.get('routes/getRouteDataById/' + routeId);
    };

    this.getRouteDataByGisId = function (routeId) {
        return $http.get('routes/getRouteDataByGisId/' + routeId);
    };

    this.getRouteGpxContent = function (routeId) {
        return $http.get('routes/getRouteGpxContent/' + routeId);
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/public-routes.service.js
 **/